<template>
  <div>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-tabs fixed-tabs dark :background-color="`${buttonColor}`" v-model="tab">
            <v-tab>{{ $t("registerEvent.registration") }}</v-tab>
            <v-tab :disabled="!bShowDescription" @click="getEventDescription">{{ $t("registerEvent.description")
              }}</v-tab>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>

    <v-row no-gutters class="mb-4">
      <v-col cols="12" class="px-2 pb-2">
        <v-tabs-items v-model="tab">
          <v-tab-item>
            <v-row>

              <v-col md="6" cols="12">
                <WarningAlert>
                  <!-- Gate fee title -->
                  <p class="mb-0 font-weight-bold" style="font-size: 20px;">{{ $t("registerEvent.alert_gate_1") }}</p>
                  
                  <!-- General instruction for adding everyone. Margin is adjusted if waiver message is hidden -->
                  <p :class="waiverBam ? 'mb-0' : ''" :style="waiverBam ? 'margin-bottom:0;' : ''">{{ $t("registerEvent.alert_gate_2") }}</p>
                  
                  <!-- Only show the waiver requirement message if the event has a spectator waiver (waiverBam is true) -->
                  <p v-if="waiverBam">{{ $t("registerEvent.alert_gate_3") }}</p>
                  
                  <!-- New bold red warning message about gate fee validation -->
                  <p class="red--text font-weight-bold mb-0 mt-2">{{ $t("registerEvent.alert_gate_4") }}</p>
                </WarningAlert>
              </v-col>
            </v-row>
            <!-- datatable riders -->
            <v-row>
              <v-col md="12" sm="12" cols="12" class="pb-0">
                <v-btn v-if="addSpectatorBand" :color="`${buttonColor}`" class="btn_next mr-12 my-1"
                  @click="addSpectator">{{ $t("registerEvent.add_spectator") }}</v-btn>
                <v-btn v-if="signedEventWaiverAll && waiverBam" :color="`${buttonColor}`" class="btn_next mr-12 my-1"
                  @click="addSignedEventWaiver">{{ $t("registerEvent.sign_event_waiver") }}</v-btn>
              </v-col>
              <v-col md="12" sm="12">
                <v-data-table 
                  :headers="spectatorHeader" 
                  :items="registrationObj.spectators"
                  :options="{ itemsPerPage: -1 }" 
                  sort-by="name" 
                  class="elevation-1 dt_part" 
                  item-key="userId"
                  :item-class="rowClass" 
                  dense
                  :footer-props="{
                    'items-per-page-text': $t('dataTable.rowsPerPageText'),
                    'items-per-page-all-text': $t('dataTable.rowsPerPageAllText')
                  }"
                  :no-data-text="$t('dataTable.noDataText')"
                  :headerProps="{
                    'sort-by-text': $t('dataTable.sortByText')
                  }"
                >
                  <template v-slot:header.selected="">
                        <v-checkbox @change="updateAllChecks($event)" v-model="allCheck"></v-checkbox>
                    </template>
                  <template v-slot:[`item.selected`]="{ item }">
                    <v-checkbox v-model="item.selected" @change="updateCheck($event)"></v-checkbox>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <span v-if="item.disabled"
                      :style="`${item.statusColor != '' ? `color: ${item.statusColor}` : ''};`">{{ item.status }}</span>
                    <template v-else>{{ item.status }}</template>
                  </template>
                  <template v-slot:[`item.eventWaiver`]="{ item }">
                    <span v-if="item.eventWaiver == 'NotSigned' || item.eventWaiver == 'Not Signed'">
                      <v-icon @click="getWaivers(item)">far fa-question-circle</v-icon>
                      <span :style="`${item.colorEventWaiver ? 'color: red;' : ''}`"> {{ $t("common.NotSigned")
                        }}</span>
                    </span>
                    <span v-if="item.eventWaiver == 'Signed'">{{ $t("common.Signed") }}</span>
                    <span v-if="item.eventWaiver == 'Rejected'">
                      <v-icon @click="getWaivers(item)">far fa-question-circle</v-icon>
                      <span :style="`${item.colorEventWaiver ? 'color: red;' : ''}`"> {{ $t("common.Rejected") }}</span>
                    </span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-tab-item>
          <v-tab-item>
            <DescriptionEvent :registrationObj="registrationObj" :eventDescription="eventDescription" />
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="6">
        <v-btn :color="`${buttonColor}`" class="btn_next my-1" v-model="step" @click="nextStep(stepBack);">{{
            $t("registerEvent.prev") }}</v-btn>
      </v-col>
      <v-col cols="6">
        <v-btn :color="`${buttonColor}`" class="btn_next my-1 float-right" v-model="step" @click="validateSpectators"
          :loading="loadingToStepParticipant">{{ $t("registerEvent.next") }}</v-btn>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogWarning" max-width="450px">
      <v-card>
        <v-card-title>{{ $t("common.warning") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text--primary mt-4">
          {{ $t("registerEvent.warning_spectator") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="buttonColor" @click="dialogWarning = false" class="white--text mx-1">{{ $t("common.ok")
            }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="add_people" max-width="450px">
      <v-card>
        <v-card-title>{{ $t("registerEvent.add_people") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text--primary">
          {{ $t("registerEvent.alert_people") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions style="text-align: center;">
          <v-spacer></v-spacer>
          <v-btn :color="buttonColor" @click="addRacer()" class="white--text mx-1">{{ $t("registerEvent.racer")
            }}</v-btn>
          <v-btn :color="buttonColor" class="white--text mx-1" @click="addOther()">
            {{ $t("registerEvent.other") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <div id="framefixerextreme" style="height: 0 !important;">
      <v-app id="inspire" style="height: 0 !important;">
        <v-row justify="center">
          <v-dialog v-model="waiverModal" persistent width="unset">

            <v-card ref="waiverModalParticipant">
              <v-card-text class="px-sm-6 px-0">
                <WaiverEvent ref="waiverEvent" :waivers="waiverE" :registrationObj="registrationObj"
                  @nextSignItem="nextSignItem" />
              </v-card-text>

            </v-card>
          </v-dialog>
        </v-row>
      </v-app>
    </div>

    <v-dialog v-model="alertQuestion" max-width="700px">
      <v-card>
        <v-card-title>{{ $t("common.warning") }}</v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text--primary">
          {{ $t("eventWaiver.alert_racer_or_participant") }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn :color="buttonColor" @click="alertQuestion = false" class="white--text mx-1">{{ $t("common.cancel")
            }}</v-btn>
          <v-btn :color="buttonColor" class="white--text mx-1" @click="confirm('Spectator')">
            {{ $t("eventWaiver.alert_spectator") }}
          </v-btn>
          <v-btn :color="buttonColor" class="white--text mx-1" @click="confirm('Participant')">
            {{ $t("eventWaiver.alert_participant") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <WaiverDialog 
      ref="waiverDialog" 
      :promoterName="promoterName" 
      :waiverDialog="waiverRequiredDialog"
      :bSend="bSendWaiver" 
      @changeField="changeField" 
      @showAlert="(v) => $emit('showAlert', v)"
      @alertNotValidate="(v) => $emit('alertNotValidate',v)" 
      @addWaiver="addWaiver"
      @refreshWaiverStatus="handleRefreshWaiverStatus" 
      componentFather="StepSpectator"
    />

  </div>
</template>

<script>
import
{
  VRow, VCol, VBtn, VDataTable, VCheckbox, VDialog, VCard, VCardTitle, VCardText, VDivider, VSpacer, VCardActions,
  VApp, VTabs, VTab, VTabItem, VTabsItems, VIcon
} from 'vuetify/lib';
import LocalStorageService from "@/services/LocalStorageService";
import WarningAlert from "@/components/alert/WarningAlert";
import WaiverEvent from "@/components/waiver/WaiverEventSpectator";
import { mapState } from "vuex";
import EventWaiverService from "@/services/EventWaiverService";
import DescriptionEvent from "@/components/eventRegistration/DescriptionEvent";
import WaiverDialog from "@/components/eventRegistration/components/WaiverDialog";

export default {
  components: {
    VRow, VCol, VBtn, VDataTable, VCheckbox, DescriptionEvent, WaiverDialog,
    VDialog, VCard, VCardTitle, VCardText, VDivider, VSpacer, VCardActions, WarningAlert,
    WaiverEvent, VApp, VTabs, VTab, VTabItem, VTabsItems, VIcon
  },
  props: {
    step: Number, registrationObj: Object, loadingToStepParticipant: { type: Boolean, default: false },
    eventDescription: String
  },
  data()
  {
    return {
      buttonColor: "#000",
      dialogWarning: false,
      add_people: false,
      cont: 0,
      waiverBam: false,
      waiverModal: false,
      waiverE: {},
      alertQuestion: false,
      waiverEArray: [],
      selectedSigWaiver: [],
      resetWaiver: false,
      tab: 0,
      itemSelected: null,
      role: 'Spectator',
      waiverRequiredDialog: false,
      bSendWaiver: false,
      allCheck: false
    }
  },
  computed: {
    ...mapState({
      userStore: (state) => state.session.user,
      languages: (state) => state.constants.languages,
      roleActive: (state) => state.waiverDialog.roleActive
    }),
    spectatorHeader()
    {
      let header = [
        { text: this.$t("registerEvent.selected"), value: 'selected', width: "10%", sortable: false },
        { text: this.$t("riders.first_name"), align: "", value: "firstName" },
        { text: this.$t("riders.last_name"), value: "lastName" },
        { text: this.$t("riders.status"), value: "status" }
      ];
      let vm = this
      const filterEventWaivers = Array.isArray(this.registrationObj.spectators) ? this.registrationObj.spectators.filter((el) =>
      {
        return (el.eventWaiver && el.eventWaiver != "");
      }) : [];
      if (filterEventWaivers.length > 0)
      {
        vm.waiverBam = true;
        header.push({ text: this.$t("riders.event_waiver"), value: "eventWaiver", align: "center" });
      }
      return header;
    },
    spectatorsSel()
    {
      const spects = Array.isArray(this.registrationObj.spectators) ? this.registrationObj.spectators.filter((el) =>
      {
        return el.selected;
      }) : [];
      return spects;
    },
    leftOpen()
    {
      return this.registrationObj.eventSel.leftOpen;
    },
    stepBack()
    {
      const backStep = this.step - 1;
      return backStep > 0 ? backStep : 1;
    },
    signedEventWaiverAll()
    {
      if (this.registrationObj)
      {
        const waiverFailed = Array.isArray(this.registrationObj.spectators) ? this.registrationObj.spectators.filter((el) =>
        {
          return el.eventWaiver && el.eventWaiver != "Signed" && el.eventWaiver != "";
        }) : [];
        return waiverFailed.length > 0;
      }
      return false;
    },
    addSpectatorBand()
    {
      if (this.registrationObj && this.registrationObj.eventSel)
      {
        return !!this.registrationObj.eventSel.isSpectatorRegistration;
      }
      return false;
    },
    promoterName()
    {
      if (this.registrationObj && this.registrationObj.promoterSel)
      {
        return this.registrationObj.promoterSel.promoterName;
      }
      return '';
    },
    ageAdult() {
      try {
      if (this.registrationObj?.eventSel?.adultAge) {
          return this.registrationObj.eventSel.adultAge;
        }
        return 18;
      } catch {
        return 18;
      }
    }
  },
  methods: {
    handleRefreshWaiverStatus() {
      this.$emit('refreshEventWaiverStatus', 'spectators');
    },
    bShowDescription()
    {
      if (this.registrationObj.eventSel)
      {
        return (
          (this.registrationObj.eventSel.address || "").length > 0 ||
          (this.registrationObj.eventSel.city || "").length > 0 ||
          (this.registrationObj.eventSel.state || "").length > 0 ||
          (this.registrationObj.eventSel.country || "").length > 0 ||
          (this.registrationObj.eventSel.zip || "").length > 0 ||
          (this.eventDescription || "").length > 0
        );
      }
      return false;
    },
    getEventDescription()
    {
      this.$emit('getEventDescription');
    },
    updateAllChecks(checkboxStatus) 
    {
      const spectators = this.registrationObj.spectators.filter(item => item.selected != checkboxStatus);
      if (spectators.length > 0)
      {
        spectators.forEach((spectator) => {
          spectator.selected = checkboxStatus;
        });
      }
    },
    confirm(val, userId = null)
    {
      let vm = this
      let _selected = Array.isArray(this.registrationObj.spectators) ? this.registrationObj.spectators.filter(x => x.selected) : [];
      this.alertQuestion = false
      userId = userId ? userId : _selected[0].userId;
      EventWaiverService.generateWaiverForEventWaiverSignedType(this.registrationObj.eventSel.id, val, userId).then((resp) =>
      {
        if (resp.data.message)
        {
          let waiverE = (resp.data.message.waiverStatus == 'NotSigned' || resp.data.message.waiverStatus == 'Not Signed' || resp.data.message.waiverStatus == 'Rejected') ? resp.data.message : false;
          if (waiverE)
          {
            vm.waiverEArray.push(waiverE);
          } else
          {
            const signed = resp.data.message.waiverStatus == 'Signed' ? true : false;
            if (!signed)
            {
              this.generateWaiver(val, userId);
            } else
            {
              this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_not_found'));
            }
          }
        } else
        {
          this.generateWaiver(val, userId);
        }
      });
    },
    generateWaiver(val, userId = null)
    {
      let vm = this
      let _selected = Array.isArray(this.registrationObj.spectators) ? this.registrationObj.spectators.filter(x => x.selected) : [];
      userId = userId ? userId : _selected[0].userId;
      let data = {
        eventsId: [
          {
            id: this.registrationObj.eventSel.id,
            usersId: [{ id: userId, roles: [val] }]
          }
        ]
      };
      EventWaiverService.generateWaiverForSpectator(data).then((response) =>
      {
        if (response.data.success && response.data.message.length > 0)
        {
          let waiversE = response.data.message;
          waiversE.forEach((waiverItem) =>
          {
            let waiversItem = waiverItem.waivers;
            waiversItem.forEach((waiverE) =>
            {
              if (waiverE)
              {
                vm.waiverEArray.push(waiverE)
              } else
              {
                this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_no_generate'));
              }
            });
          });
        } else
        {
          this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_no_generate'));
        }
      })
    },
    nextSignItem()
    {
      this.waiverModal = false
      this.waiverEArray = Array.isArray(this.waiverEArray) ? this.waiverEArray.filter((item) => { return item.id != this.waiverE.id; }) : [];
      if (this.waiverEArray.length == 0)
      {
        this.resetWaiver = false;
        this.$store.commit('setOverlay', false);
        this.$emit('refreshEventWaiverStatus', 'spectators');
        if (this.waiverRequiredDialog)
        {
          this.getWaivers(this.itemSelected);
        }
      }
    },
    nextStep(step)
    {
      this.$emit('nextStep', step);
    },
    validateSpectators()
    {
      this.$emit('validateSpectators', false, false);
    },
    changeTab(newValue)
    {
      this.tab = newValue;
    },
    updateCheck()
    {
      this.$emit('updateSpectators');
    },
    rowClass(item)
    {
      let rowClass = "";
      if (item.disabled || item.disabledStatus)
        rowClass = "grayC";
      return rowClass;
    },
    addSpectator()
    {
      this.add_people = true
    },
    addRacer()
    {
      this.add_people = false
      LocalStorageService.setItem('active_event_registration', true);
      LocalStorageService.setItem("link_back_spect", this.$route.name);
      this.$router.push({
        path: "RidersCreate"
      });
    },
    addOther()
    {
      this.add_people = false
      LocalStorageService.setItem('active_event_registration', true);
      LocalStorageService.setItem("link_back_spect", this.$route.name);
      this.$router.push({
        path: "SpectatorsCreate"
      });
    },
    addSignedEventWaiver()
    {
      let _selected = Array.isArray(this.registrationObj.spectators) ? this.registrationObj.spectators.filter(x => x.selected) : [];
      let band = false;
      let bandMsg = false;
      let bandReview = false;
      if (_selected.length > 0)
      {
        for (let i = 0; i < _selected.length; i++)
        {
          if (_selected[i].eventWaiver == "NotSigned" || _selected[i].eventWaiver == "Not Signed" || _selected[i].eventWaiver == "Rejected")
          {
            bandReview = true;
          }
          const birthday = Object.prototype.hasOwnProperty.call(_selected[i],'birthdayString') ? _selected[i].birthdayString : _selected[i].birthday;
          if (
            (_selected[i].eventWaiver == "NotSigned" || _selected[i].eventWaiver == "Not Signed" || _selected[i].eventWaiver == "Rejected") &&
            this.age18Calculate(birthday) && this.userStore.id != _selected[i].userId
          )
          {
            band = true;
          }
          if ((!_selected[i].eventWaiver) && !this.age18Calculate(birthday)) 
          {
            bandMsg = true;
          }
        }
      } else
      {
        band = true;
      }
      if (!bandReview && bandMsg)
      {
        this.$emit('alertNotValidate', this.$t('eventWaiver.waiver_not_signed_alert'));
        return;
      }
      if (!band)
      {
        this.selectedSigWaiver = _selected;
        this.waiverEArray = [];
        this.$store.commit('setOverlay', true);
        let bandOverlay = false;
        let selectedNotSigned = _selected.filter((el) => el.eventWaiver == 'NotSigned' || el.eventWaiver == 'Not Signed' || el.eventWaiver == 'Rejected');
        if (selectedNotSigned.length > 0)
        {
          _selected.forEach(async (item, i) =>
          {
            if (item.eventWaiver == "NotSigned" || item.eventWaiver == "Not Signed" || item.eventWaiver == "Rejected")
            {
              let userId = item.userId
              await this.generateWaiver(this.role, userId);
              if (item.eventWaiver == "Signed") this.$emit('validateSpectatorsWaiver');
            }
            if (i == (_selected.length - 1) && !bandOverlay)
            {
              this.$store.commit('setOverlay', false);
            }
          });
        } else
        {
          this.$store.commit('setOverlay', false);
          this.$emit('alertNotValidate', this.$t("eventWaiver.not_waiver_signed"));
        }

      } else
      {
        LocalStorageService.setItem("link_back_event_waiver", this.$route.name);
        LocalStorageService.setItem("typeStep", this.role);
        this.$emit("openmenu", "events");
        this.$router.push({
          path: "EventWaiverCreate",
          query: { eventId: this.registrationObj.eventSel.id }
        });
      }
    },
    confirmNextStep()
    {
      this.$emit('confirmNextStep');
      this.dialogWarning = false;
    },
    age18Calculate(birthdayCurrent)
    {
      const nowDay = new Date();
      nowDay.setFullYear(nowDay.getFullYear() - this.ageAdult);
      if (birthdayCurrent)
      {
        const birthday = new Date(birthdayCurrent);
        return birthday <= nowDay;
      }
      return false;
    },
    async getWaivers(participant)
    {
      const waiverData = {
        eventId: this.registrationObj.eventSel.id,
        userId: participant.userId,
        role: this.role,
        promoterId: this.registrationObj.promoterSel.promoterId
      };
      this.$store.dispatch('SET_WAIVER_DATA_ACTION', waiverData);
      this.itemSelected = participant;
      let eventID = this.registrationObj.eventSel.id;
      let data = {
        eventsId: [
          {
            id: eventID,
            usersId: [
              {
                id: participant.userId,
                roles: [this.role]
              }
            ]
          }
        ]
      };
      this.$store.dispatch('SET_WAIVERS_FOR_DIALOG_ACTION', []);

      let response = await EventWaiverService.getWaiversForUser(data);

      if (response.data.success)
      {
        let waiversUser = response.data.message[0].usersId[0].roles.find((el) =>
        {
          return el.userRoleCode == this.role;
        }).waivers.map((el) =>
        {
          let waiverTranslate = {};
          this.languages.forEach((language) =>
          {
            waiverTranslate[language.value] = false;
          });
          if (el.waiverTranslate.length > 0)
          {
            waiverTranslate.first = el.waiverTranslate[0];
          }
          el.waiverTranslate.forEach((itemTranslate) =>
          {
            waiverTranslate[itemTranslate.languageCode] = itemTranslate;
          });
          const birthday = Object.prototype.hasOwnProperty.call(participant,'birthdayString') ? participant.birthdayString : participant.birthday;
          return {
            ...el.waiverData,
            waiverTranslate,
            waiverstatus: el.status,
            userId: participant.userId,
            fullName: `${participant.firstName} ${participant.lastName}`,
            participantEmail: participant.email || participant.emailAddress || '',
            age18: this.age18Calculate(birthday)
          };
        });
        this.$store.dispatch('SET_WAIVERS_FOR_DIALOG_ACTION', waiversUser);
        this.waiverRequiredDialog = true;
      } else
      {
        this.$emit('alertNotValidate', this.$t('common.error_general'));
      }
    },
    addWaiver(item)
    {
      this.waiverEArray.push(item);
    },
    changeField({ field, value })
    {
      this[field] = value;
    },
    scrollWaiverDialogTop()
    {
      this.$nextTick(() =>
      {
        const overlays = document.querySelectorAll('.v-dialog--active');
        overlays.forEach((el) => { el.scrollTop = 0; });
        if (typeof window !== 'undefined' && typeof window.scrollTo === 'function')
        {
          window.scrollTo(0, 0);
        }
      });
    }
  },
  created()
  {
    this.buttonColor = this.$store.getters.env.get('VUE_APP_BUTTON_COLOR');
  },
  updated() { },
  watch: {
    step()
    {
      this.tab = 0;
    },
    waiverEArray(val)
    {
      if (Array.isArray(val) && val.length > 0)
      {
        let valUsersID = val.find((el) => { return el.fkUserId == this.userStore.id });
        this.waiverE = val[0].fkUserId == this.userStore.id ? val[0] : (valUsersID ? valUsersID : val[0]);
        if (!this.resetWaiver)
        {
          this.resetWaiver = true;
          this.waiverModal = true;
          if (this.$refs.waiverEvent)
          {
            this.$refs.waiverEvent.$refs.waiverYou.$refs.formWaiver.resetValidation();
          }
          this.scrollWaiverDialogTop();
        } else
        {
          setTimeout(() =>
          {
            this.waiverModal = true;
            if (this.$refs.waiverEvent)
            {
              this.$refs.waiverEvent.$refs.waiverYou.$refs.formWaiver.resetValidation();
            }
            this.scrollWaiverDialogTop();
          }, 1000);
        }
      }
    },
    waiverModal(val)
    {
      if (!val)
      {
        setTimeout(() =>
        {
          if (this.$refs.waiverModalParticipant) this.$refs.waiverModalParticipant.$el.scrollIntoView();
        }, 200);
      }
    },
    waiverRequiredDialog(val)
    {
      if (!val)
      {
        const birthday = Object.prototype.hasOwnProperty.call(this.itemSelected,'birthdayString') ? this.itemSelected.birthdayString : this.itemSelected.birthday;
        if (
          this.itemSelected && this.age18Calculate(birthday) &&
          this.userStore.id != this.itemSelected.userId/* && this.bSendWaiver*/
        )
        {
          this.bSendWaiver = false;
          this.resetWaiver = false;
          this.$store.commit('setOverlay', false);
          this.$emit('refreshEventWaiverStatus', 'spectators');
        }
      }
    }
  }
}
</script>

<style>
@media (max-width: 960px) {
  .next1 {
    display: block;
  }

  .next2Spect {
    display: none;
  }
}

@media (min-width: 960px) {
  .next1 {
    display: none;
  }

  .next2Spect {
    display: block;
  }
}
</style>